import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import tailwindConfig from '../../../tailwind.config'

gsap.registerPlugin(ScrollTrigger);

export default function(){
	const ctasImage = document.querySelectorAll('[data-js=cta-image]');
	
	if ( ctasImage.length > 0 ) {
		const mobileScreen = tailwindConfig.theme.screens.md.replace('px', '');

		ctasImage.forEach(ctaImage => {
			const ctaText        = ctaImage.nextElementSibling
			const ctaImageWidth  = ctaImage.offsetWidth;
			const ctaImageHeight = ctaImage.offsetHeight;

			let ctaTl = gsap.timeline({
				defaults: {
					duration: 0.8,
					ease: 'none'
				},
				scrollTrigger: {
					trigger: ctaImage,
					start: 'top bottom-=400',
					end: 'center center',
					scrub: 1,
					//markers: true
				}
			})

			if ( window.innerWidth < mobileScreen ) {
				ctaTl
				.fromTo(ctaText, { y: - ctaImageHeight }, { y: 0 }, '<')
			} else {
				ctaTl
					.fromTo(ctaImage, { x: ctaImageWidth / 2 }, { x: 0 })
					.fromTo(ctaText, { x: - ctaImageWidth / 2 }, { x: 0 }, '<')
			}
		});
	}
}